import { StyleSheet } from '@react-pdf/renderer';
import COLORS from '../../resources/style/Themes';
import Logo from '../../resources/images/WebAppLogo.png';
import { View, Image } from '@react-pdf/renderer';

const reportStyles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  logo: {
    width: 150,
    height: 'auto',
    padding: 10,
    marginLeft: 10,
    marginTop: 10,
    backgroundColor: COLORS.SAFEGUARD_BLUE,
  },
});

export const SafeguardLogo = () => (
  <View style={reportStyles.row}>
    <Image src={Logo} style={reportStyles.logo} />
  </View>
);
